import { useRef, useState, useEffect } from "react";
import { ImagePlus, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useApi, errMsg, photoUrl } from "@/lib/api";

export function PhotoUploader({ value, onChange, max = 8, privateFiles = false, testid = "photo-uploader" }) {
  const api = useApi();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFiles = async (files) => {
    setBusy(true);
    const next = [...value];
    for (const f of Array.from(files).slice(0, max - value.length)) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const { data } = await api.post(`/uploads?visibility=${privateFiles ? "private" : "public"}`, fd);
        next.push(data.path);
      } catch (e) {
        toast.error(errMsg(e));
      }
    }
    onChange(next);
    setBusy(false);
  };

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-3" data-testid={testid}>
      {value.map((p, i) => (
        <div key={p} className="relative aspect-square rounded-xl overflow-hidden border border-stone-200">
          {privateFiles ? <AuthImg path={p} className="w-full h-full object-cover" /> : <img src={photoUrl(p)} alt="" className="w-full h-full object-cover" />}
          <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(value.filter((x) => x !== p))} className="absolute top-1 right-1 bg-white/90 rounded-full p-1" aria-label="Retirer">
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
      {value.length < max && (
        <button type="button" data-testid={`${testid}-add`} onClick={() => input.current?.click()} className="aspect-square rounded-xl border-2 border-dashed border-stone-300 flex flex-col items-center justify-center text-stone-500 hover:border-forest hover:text-forest transition-colors">
          {busy ? <Loader2 className="w-6 h-6 animate-spin" /> : <ImagePlus className="w-6 h-6" />}
          <span className="text-xs mt-1">Ajouter</span>
        </button>
      )}
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" multiple hidden data-testid={`${testid}-input`} onChange={(e) => e.target.files && onFiles(e.target.files)} />
    </div>
  );
}

export function AuthImg({ path, className }) {
  const api = useApi();
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u;
    api.get(`/files/${path}`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => {});
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [api, path]);
  return url ? <img src={url} alt="" className={className} /> : <div className={`bg-muted ${className}`} />;
}
